import { doc, getDoc, setDoc, updateDoc, Timestamp, collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Atualiza o agregado de tipos de transação quando um tipo é criado
 */
export const updateTransactionTypesAggregationOnCreate = async (typeData) => {
  try {
    if (!typeData || !typeData.id) {
      return;
    }

    const transactionTypesAggregateRef = doc(db, 'agregadoTiposTransacao', 'all');
    const transactionTypesAggregateDoc = await getDoc(transactionTypesAggregateRef);
    
    const typeEntry = {
      id: typeData.id,
      nome: typeData.nome || '',
      categoria: typeData.categoria,
      criadoEm: typeData.criadoEm || null,
      atualizadoEm: typeData.atualizadoEm || null
    };
    
    if (!transactionTypesAggregateDoc.exists()) {
      // Se o agregado não existe, buscar todos os tipos e criar o agregado
      const allTypesSnapshot = await getDocs(collection(db, 'tiposTransacao'));
      const allTypes = allTypesSnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          nome: data.nome || '',
          categoria: data.categoria,
          criadoEm: data.criadoEm || null,
          atualizadoEm: data.atualizadoEm || null
        };
      });
      
      // Verificar se o tipo atual já está na lista
      const existingTypeIndex = allTypes.findIndex(t => t.id === typeData.id);
      if (existingTypeIndex === -1) {
        allTypes.push(typeEntry);
      } else {
        allTypes[existingTypeIndex] = typeEntry;
      }
      
      // Ordenar por nome
      allTypes.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
      
      await setDoc(transactionTypesAggregateRef, {
        tiposTransacao: allTypes,
        quantidadeTotal: allTypes.length,
        ultimaAtualizacao: Timestamp.now()
      });
      return;
    }

    const currentData = transactionTypesAggregateDoc.data();
    const transactionTypes = currentData.tiposTransacao || [];
    
    const existingIndex = transactionTypes.findIndex(t => t.id === typeData.id);
    
    if (existingIndex === -1) {
      transactionTypes.push(typeEntry);
      // Ordenar por nome
      transactionTypes.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
      
      await updateDoc(transactionTypesAggregateRef, {
        tiposTransacao: transactionTypes,
        quantidadeTotal: transactionTypes.length,
        ultimaAtualizacao: Timestamp.now()
      });
    } else {
      // Tipo já existe no agregado, atualizando em vez de adicionar
      transactionTypes[existingIndex] = typeEntry;
      transactionTypes.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
      
      await updateDoc(transactionTypesAggregateRef, {
        tiposTransacao: transactionTypes,
        quantidadeTotal: transactionTypes.length,
        ultimaAtualizacao: Timestamp.now()
      });
    }
  } catch (error) {
    // Erro ao atualizar agregado de tipos de transação (create)
    throw error;
  }
};

/**
 * Atualiza o agregado de tipos de transação quando um tipo é atualizado
 */
export const updateTransactionTypesAggregationOnUpdate = async (typeData) => {
  try {
    if (!typeData || !typeData.id) {
      return;
    }

    const transactionTypesAggregateRef = doc(db, 'agregadoTiposTransacao', 'all');
    const transactionTypesAggregateDoc = await getDoc(transactionTypesAggregateRef);
    
    if (!transactionTypesAggregateDoc.exists()) {
      // Se o agregado não existe, buscar todos os tipos e criar o agregado
      const allTypesSnapshot = await getDocs(collection(db, 'tiposTransacao'));
      const allTypes = allTypesSnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          nome: data.nome || '',
          categoria: data.categoria,
          criadoEm: data.criadoEm || null,
          atualizadoEm: data.atualizadoEm || null
        };
      });
      
      // Verificar se o tipo atual já está na lista
      const existingTypeIndex = allTypes.findIndex(t => t.id === typeData.id);
      const typeEntry = {
        id: typeData.id,
        nome: typeData.nome || '',
        categoria: typeData.categoria,
        criadoEm: typeData.criadoEm || null,
        atualizadoEm: typeData.atualizadoEm || null
      };
      
      if (existingTypeIndex === -1) {
        allTypes.push(typeEntry);
      } else {
        allTypes[existingTypeIndex] = typeEntry;
      }
      
      // Ordenar por nome
      allTypes.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
      
      await setDoc(transactionTypesAggregateRef, {
        tiposTransacao: allTypes,
        quantidadeTotal: allTypes.length,
        ultimaAtualizacao: Timestamp.now()
      });
      return;
    }

    const currentData = transactionTypesAggregateDoc.data();
    const transactionTypes = currentData.tiposTransacao || [];
    
    const typeEntry = {
      id: typeData.id,
      nome: typeData.nome || '',
      categoria: typeData.categoria,
      criadoEm: typeData.criadoEm || null,
      atualizadoEm: typeData.atualizadoEm || null
    };
    
    const existingIndex = transactionTypes.findIndex(t => t.id === typeData.id);
    
    if (existingIndex !== -1) {
      transactionTypes[existingIndex] = typeEntry;
      // Ordenar por nome
      transactionTypes.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
      
      await updateDoc(transactionTypesAggregateRef, {
        tiposTransacao: transactionTypes,
        quantidadeTotal: transactionTypes.length,
        ultimaAtualizacao: Timestamp.now()
      });
    } else {
      // Tipo não encontrado no agregado, adicionando
      transactionTypes.push(typeEntry);
      transactionTypes.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
      
      await updateDoc(transactionTypesAggregateRef, {
        tiposTransacao: transactionTypes,
        quantidadeTotal: transactionTypes.length,
        ultimaAtualizacao: Timestamp.now()
      });
    }
  } catch (error) {
    // Erro ao atualizar agregado de tipos de transação (update)
    throw error;
  }
};

/**
 * Atualiza o agregado de tipos de transação quando um tipo é deletado
 */
export const updateTransactionTypesAggregationOnDelete = async (typeId) => {
  try {
    if (!typeId) {
      return;
    }

    const transactionTypesAggregateRef = doc(db, 'agregadoTiposTransacao', 'all');
    const transactionTypesAggregateDoc = await getDoc(transactionTypesAggregateRef);
    
    if (!transactionTypesAggregateDoc.exists()) {
      // Se o agregado não existe, buscar todos os tipos (exceto o deletado) e criar o agregado
      const allTypesSnapshot = await getDocs(collection(db, 'tiposTransacao'));
      const allTypes = allTypesSnapshot.docs
        .map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            nome: data.nome || '',
            categoria: data.categoria,
            criadoEm: data.criadoEm || null,
            atualizadoEm: data.atualizadoEm || null
          };
        })
        .filter(t => t.id !== typeId); // Remover o tipo deletado
      
      // Ordenar por nome
      allTypes.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
      
      await setDoc(transactionTypesAggregateRef, {
        tiposTransacao: allTypes,
        quantidadeTotal: allTypes.length,
        ultimaAtualizacao: Timestamp.now()
      });
      return;
    }

    const currentData = transactionTypesAggregateDoc.data();
    const transactionTypes = currentData.tiposTransacao || [];
    
    const filteredTypes = transactionTypes.filter(t => t.id !== typeId);
    
    await updateDoc(transactionTypesAggregateRef, {
      tiposTransacao: filteredTypes,
      quantidadeTotal: filteredTypes.length,
      ultimaAtualizacao: Timestamp.now()
    });
  } catch (error) {
    // Erro ao atualizar agregado de tipos de transação (delete)
    throw error;
  }
};

